import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

export const getIsAllTeethInROI = (reportTeeth: Tooth[]) =>
  reportTeeth.length !== 0 &&
  reportTeeth.every((tooth) => tooth.IsInROI === true);
